/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { IconButton } from "@mui/material";
import styles from "../QuoteMultipleDestinationsPanel.module.css";
import { XIcon, RailIconFO, TruckIconFO } from "../../../icons";
import { useNitroCAStore } from "../../../store/CompetitiveAnalysisStore";
import { useNitroStore } from "../../../store/Store";
import {
  updateInboundModes,
} from "./multiLocationQuoteUtils";
import IModes from "../../../types/IModes";
import IOSSwitch from "../../../components/IOSSwitch";

const InboundModeTogglePanel: React.FC<{ inboundModes: IModes }> = ({
  inboundModes,
}) => {
  const [
    setDisplayInboundModeTogglePanel,
    anchorForInboundModesTogglePanel,
    setDisplayAddInboundRailPanel,
    setDisplayTurnOffModePanel,
    setModeToTurnOff,
    destination,
    setExpandedDestination,
  ] = useNitroCAStore((state) => [
    state.setDisplayInboundModeTogglePanel,
    state.anchorForInboundModesTogglePanel,
    state.setDisplayAddInboundRailPanel,
    state.setDisplayTurnOffModePanel,
    state.setModeToTurnOff,
    state.destinationToTroubleshoot,
    state.setExpandedDestination,
  ]);
  const [setMultiLocationDestinations] =
    useNitroStore((state) => [
      state.setMultiLocationDestinations,
    ]);
  const triggerRefetchMultiLocation = useNitroCAStore(
    (state) => state.triggerRefetchMultiLocation,
  );
  const [checkedTruck, setCheckedTruck] = useState(inboundModes.TRUCK.inbound);
  const [checkedRail, setCheckedRail] = useState(inboundModes.RAIL.inbound);
  const rect = anchorForInboundModesTogglePanel?.getBoundingClientRect();
  const anchorPosition = rect
    ? { top: rect.bottom, left: rect.left - 40 }
    : { top: 0, left: 0 };

  // effects to handle toggling inbound modes
  // TRUCK
  useEffect(() => {
    // OFF: truck was checked and is now unchecked
    if (!checkedTruck && inboundModes.TRUCK.inbound !== checkedTruck) {
      // show turn off confirmation panel
      setModeToTurnOff("TRUCK");
      setDisplayTurnOffModePanel(true);
    }
    // ON: truck was unchecked and is now checked
    if (checkedTruck && inboundModes.TRUCK.inbound !== checkedTruck) {
      updateInboundModes(destination, true, "TRUCK");
      // upon successful update close panels, refetch data, and expand destination
      setDisplayInboundModeTogglePanel(false);
      setMultiLocationDestinations([]);
      triggerRefetchMultiLocation();
      setExpandedDestination(
        {
          id: destination.id,
          name: destination.name,
        },
        {
          expandTruckWithNoFreight: true,
          expandSurroundingLocations: destination.isSurroundingLocation,
        },
      );
    }
  }, [checkedTruck]);

  // RAIL
  useEffect(() => {
    // OFF: rail was checked and is now unchecked
    if (!checkedRail && inboundModes.RAIL.inbound !== checkedRail) {
      // show turn off confirmation panel
      setModeToTurnOff("RAIL");
      setDisplayTurnOffModePanel(true);
    }
    // ON: rail was unchecked and is now checked
    if (checkedRail && inboundModes.RAIL.inbound !== checkedRail) {
      // show add inbound rail panel
      setDisplayAddInboundRailPanel(true);
    }
  }, [checkedRail]);

  return (
    <div
      className={styles.inboundModesTogglePanelContainer}
      style={{
        top: anchorPosition.top,
        left: anchorPosition.left,
      }}
    >
      {/* Title */}
      <div className={styles.inboundModesToggleTitleContainer}>
        <div className={styles.inboundModesToggleTitle}>Inbound Modes</div>
        <IconButton
          size="small"
          onClick={() => setDisplayInboundModeTogglePanel(false)}
          data-testid="InboundModeTogglePanel-x-button"
        >
          <XIcon />
        </IconButton>
      </div>
      {/* Content */}
      <div className={styles.inboundModesToggleContent}>
        <div className={styles.inboundModesToggleTextContainer}>
          <TruckIconFO color="#60A5FA" size="20" />
          <span
            className={styles.inboundModesToggleText}
            style={{ paddingRight: "45px" }}
          >
            Truck
          </span>
          <IOSSwitch
            data-testid="InboundModeTogglePanel-truck-switch"
            checked={checkedTruck}
            onChange={() => {
              setCheckedTruck(!checkedTruck);
            }}
          />
        </div>
        <div className={styles.inboundModesToggleTextContainer}>
          <RailIconFO color="#F97316" size="20" />
          <span
            className={styles.inboundModesToggleText}
            style={{ paddingRight: "63px" }}
          >
            Rail
          </span>
          <IOSSwitch
            data-testid="InboundModeTogglePanel-rail-switch"
            checked={checkedRail}
            onChange={() => {
              setCheckedRail(!checkedRail);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default InboundModeTogglePanel;
